import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Dialog de confirmação simples, estilizado no tema dark do Linkia.
 */
export default function ConfirmDialog({
    open,
    title = "Tem certeza?",
    description = "",
    confirmLabel = "Confirmar",
    cancelLabel = "Cancelar",
    onConfirm,
    onCancel,
    loading = false,
    destructive = false,
    testId = "confirm-dialog",
}) {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center p-4 fade-in"
            data-testid={testId}
        >
            <div
                className="absolute inset-0 bg-black/75 backdrop-blur-sm"
                onClick={loading ? undefined : onCancel}
            />
            <div className="relative w-full max-w-sm bg-[#111111] border border-border rounded-sm shadow-2xl overflow-hidden">
                <div className="px-6 pt-6 pb-4">
                    <h3 className="font-display text-lg font-bold tracking-tight mb-1.5">{title}</h3>
                    {description && (
                        <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
                    )}
                </div>
                <div className="flex border-t border-border">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={loading}
                        data-testid={`${testId}-cancel`}
                        className="flex-1 py-3 text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-colors disabled:opacity-50"
                    >
                        {cancelLabel}
                    </button>
                    <div className="w-px bg-border" />
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        data-testid={`${testId}-confirm`}
                        className={`flex-1 py-3 text-sm font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-50 ${
                            destructive
                                ? "text-destructive hover:bg-destructive/10"
                                : "text-primary hover:bg-primary/10"
                        }`}
                    >
                        {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
